import { AnalyticsBrowser } from '@segment/analytics-next';
const createSegmentClient = () => {
  let _client;
  const initialize = config => {
    _client = AnalyticsBrowser.load({
      writeKey: config.writeKey
    });
  };
  const track = (event, properties) => {
    _client?.track(event, properties);
  };
  return {
    initialize,
    track
  };
};
const segmentClient = createSegmentClient();
export default segmentClient;